import { z } from "zod";

export const INSTALLED_POWER_ERROR = "Indica una potencia positiva de hasta 999999999,999 kWp y un máximo de 3 decimales, o deja el campo vacío.";
// Exact decimal storage (1 W resolution). No coercion of blanks/booleans to zero.
export const installedPowerKwpSchema = z.union([z.string(), z.number().finite()])
  .transform(String)
  .refine(value => /^(?:0|[1-9]\d{0,8})(?:\.\d{1,3})?$/.test(value) && Number(value) > 0, INSTALLED_POWER_ERROR)
  .nullable().optional();

export function parseInstalledPowerInput(value: string): string | null {
  return installedPowerKwpSchema.parse(value.trim() === "" ? null : value.trim().replace(",", ".")) ?? null;
}

export function formatInstalledPower(value: string | number | null | undefined): string {
  if (value == null || value === "" || !Number.isFinite(Number(value)) || Number(value) <= 0) return "Sin registrar";
  return `${Number(value).toLocaleString("es-ES", { maximumFractionDigits: 3 })} kWp`;
}
